import request from '../../../utils/request';
import apiConstants from '../../../constants/api';
import { AppealWorkQueueTypes } from 'containers/Appeals/modules/enum';

export const getAssigneeListData = (userId: number, activeOnly: boolean) => {
  return request(`${apiConstants.getAssigneeList}?id=${userId}&activeonly=${activeOnly}`);
};

export const requestGetUserConfigs = (cfgName: string) => {
  return request(`${apiConstants.userConfigs}?cfgName=${cfgName}`, {
    method: 'get',
  });
};

export const getAppealStatusesAll = () => {
  return request(`${apiConstants.getAppealStatus}`, {
    method: 'get',
  });
};

export const getAppealStatusesCountAll = () => {
  return request(`${apiConstants.getAppealStatusCount}`, {
    method: 'get',
  });
};

export const getAppealCountData = (status: string) => {  
  const statusLower = status.toLowerCase();
  return request(`${apiConstants.getAppealCountByType}${statusLower}`, {
    method: 'get',
  });
}

